import React, { useState, useEffect } from "react";
import axios from 'axios';
import Menu from "../Menu";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import DailyCard from "./DailyCard";
import WeeklyCardTiles from './WeeklyCardTiles'
import { BASE_URL } from "../../utils/handleApi";

const useStyles = makeStyles((theme) => ({
  header: {
    marginLeft: "7%",
    marginTop: "4%",
    fontSize: "3vw",
    color: "gray",
    fontWeight: "400",
  },
  maindiv: {
    backgroundColor: "#F0F0F0",
    marginLeft: "8.5%",
    marginRight: "8.5%",
    paddingBottom: "2%",
    borderRadius: "15px",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "1%",
      marginRight: "1%",
    },

    [theme.breakpoints.only("sm")]: {
      marginLeft: "7%",
      marginRight: "7%",
    },
  },
  textheader: {
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "400",
    paddingTop: "4%",
    marginTop: "-3%",

    color: "#484545",
  },

  carddiv: {
    paddingLeft: "2em",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "0em",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "13px",
      paddingRight: "13px",
    },
  },
 
}));

const Dashboard = () => {
  const classes = useStyles();
  const [count, setCount] = useState({});

  useEffect(() => {
    let tokenStr = localStorage.getItem('token')
    axios.get(`${BASE_URL}/order/dashboard`,{
      headers: {
        'Authorization': `Bearer ${tokenStr}`
      }
    })
    .then(res => setCount(res.data))
    .catch(err => {})
  },[]);

  return (
    <div style={{ backgroundColor: "white" }}>
      <Menu />
      <div>
        <div className="mdata">
          <Grid container>
            <Grid item>
              <h2 className="mtextOpenOrder">My Dashboard</h2>
            </Grid>
          </Grid>
        </div>
        <div style={{marginTop:'2%'}} className={classes.card2div}>
          <DailyCard 
            today={count.today_order_date_count}
            due={count.today_order_due_date_count}
            completed={count.today_order_completed_date_count}
          />
        </div>
        <div style={{ paddingBottom: "10%" }}>
          <div className={classes.maindiv}>
            <div className={classes.carddiv}>
              <WeeklyCardTiles 
                total={count.open_order_count}
                hold={count.order_on_hold_count}
                overdue={count.order_over_due_count}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
